import PlusIcon from "@/components/icons/PlusIcon";
import {useRef, useState} from "react";
import MinusIcon from "@/components/icons/MinusIcon";
import DOMPurify from 'dompurify';
import {gsap} from "gsap";
import {useGSAP} from '@gsap/react';

export default function Accordion({title, content}) {

    const [open, setOpen] = useState(false)

    const accordion = useRef(null)
    const contentWrapper = useRef(null)

    const {contextSafe} = useGSAP({scope: accordion});

    const toggle = contextSafe(() => {
        if (open) {
            gsap.to(contentWrapper.current, {
                height: 0,
                duration: 0.25
            });
        } else {
            gsap.to(contentWrapper.current, {
                height: 'auto',
                duration: 0.25
            });
        }

        setOpen(!open)
    });

    return (
        <div ref={accordion}>
            <div className={"rounded-lg bg-white hover:bg-brand-orange-light border border-inactive-grey hover:border-brand-orange overflow-hidden transition-colors"}>
                <div
                    className={"py-[24px] pl-[32px] pr-[24px] flex items-center cursor-pointer"}
                    onClick={toggle}
                >
                    <div className={"text-[20px] leading-[24px] font-bold flex-1 mr-[24px]"}>
                        {title}
                    </div>
                    {open
                        ? <MinusIcon className={"size-[25px]"}/>
                        : <PlusIcon className={"size-[25px]"}/>
                    }
                </div>
                <div ref={contentWrapper} className={'h-0 overflow-hidden'}>
                    <div
                        className={"ein-accordion rounded-b-lg bg-ice-grey border-t border-inactive-grey p-[32px] [&>:last-child]:mb-0"}
                        dangerouslySetInnerHTML={{'__html': DOMPurify.sanitize(content)}}
                    />
                </div>
            </div>
        </div>
    )
}
